<template>
  <Modal
    :model-value="props?.isOpen.value"
    :close="props?.options?.backgroundClose === false ? () => '' : hide"
    @after-leave="afterLeave"
  >
    <div class="modal-gallery" @click.self="hide">
      <!--      <span class="modal-gallery-close" @click="hide">-->
      <!--        <svg class="modal-gallery-close__icon">-->
      <!--          <use xlink:href="#svg-close"></use>-->
      <!--        </svg>-->
      <DefButtonCross class="modal-gallery-close__icon" @click="hide" />
      <!--      </span>-->
      <div
        :class="{ 'modal-gallery__wide': props?.options?.width }"
        :style="{ 'max-width': props?.options?.width }"
      >
        <slot />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
import { Ref } from 'vue';
import useModal from '@use/useModal/useModal';
import DefButtonCross from '@components/Def/DefButtonCross/DefButtonCross.vue';

const modal = useModal();

const props = defineProps<{
  isOpen: Ref;
  options?: {
    width?: string;
    backgroundClose?: boolean;
    empty?: boolean;
    padding?: boolean;
  };
  afterLeave: () => void;
}>();

const hide = () => {
  modal.hide();
};
</script>

<style lang="scss" scoped>
.modal-gallery {
  display: flex;
  align-items: center;
  justify-content: center;
  &__wide {
    width: calc(100vw - 32px);
    @include point-md {
      width: calc(100vw - 48px);
    }
  }
  :deep(.def-button-cross) {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    z-index: 2;
    @include point-md {
      top: 24px;
      right: 24px;
    }
  }
  :deep(.def-button-cross__icon) {
    width: 24px;
    height: 24px;
    fill: #fff;
  }
}
</style>
